module.exports = __webpack_public_path__ + "21_tvcg.jpg?87e33d6dccea6b2f15ce513ef2426941";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/21_tvcg.jpg
// module id = 178
// module chunks = 0